import { PureComponent, HTMLProps, MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { classNames } from '@tolkam/lib-utils-ui';
import { ITransport } from '~/state/store/Transport';
import Layer from '~/ui/react/components/Layer';
import StateContext, { IState } from '~/ui/react/contexts/state';
import Loader from '~/ui/react/components/Loader';
import './styles';

class Partial extends PureComponent<IProps, ILocalState> {

    /**
     * @inheritDoc
     */
    public static contextType = StateContext;

    /**
     * @type IState
     */
    public context: IState;

    /**
     * @type ILocalState
     */
    public state: ILocalState = {
        show: false,
        payload: null,
    };

    /**
     * @protected
     */
    protected transport: ITransport;

    /**
     * @protected
     */
    protected payloadEl: HTMLElement|null;

    /**
     * @inheritDoc
     */
    public constructor(props: IProps, context: IState) {
        super(props);
        this.transport = context.partials.transport(this.props.endpoint);
    }

    /**
     * @inheritDoc
     */
    public render() {
        const that = this;
        const { props, state } = that;
        const { pending, payload } = that.transport;
        const rootClass = 'jc-partial';

        const layerClass = classNames(rootClass, {
            '-loaded': payload != null
        });

        return <>
            <a
                onClick={that.show}
                className={classNames(rootClass + '_trigger', props.className)}
            >{props.children}</a>
            <Layer
                show={state.show}
                onCloseRequest={that.hide}
                noBackdropClicks={false}
                modifiers={[]}
                className={layerClass}
            >
                <Loader show={pending} />
                <div
                    className={rootClass + '_payload'}
                    ref={r => this.payloadEl = r}
                    dangerouslySetInnerHTML={{__html: payload as string}}
                />
            </Layer>
        </>;
    }

    /**
     * @param e
     */
    protected show = (e?: MouseEvent) => {
        const that = this;

        e && e.preventDefault();

        that.setState({show: true}, () => {
            that.context.partials.load(that.props.endpoint).then(({success}) => {
                if(success) {
                    that.context.ui.reRender(that.payloadEl!);
                } else {
                    that.hide();
                }
            });
        });
    }

    protected hide = () => {
        this.setState({show: false});
    }
}

interface ILocalState {
    show: boolean;
    payload: any;
}

interface IProps extends HTMLProps<Partial> {
    endpoint: string;
}

export default observer(Partial);
